import {
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  Grid,
  Stack,
  IconButton,
  Link,
  useTheme,
} from "@mui/material";
import { alpha } from "@mui/material/styles";
import { Add, Delete } from "@mui/icons-material";

const ProjectsStep = ({
  profileData = { projects: [] },
  projectName,
  setProjectName,
  projectDesc,
  setProjectDesc,
  projectUrl,
  setProjectUrl,
  handleProjectAdd,
  handleDeleteProject,
}) => {
  // eslint-disable-next-line no-unused-vars
  const theme = useTheme(); // CHANGED: Instantiate theme

  return (
    // CHANGED: Replaced hardcoded color with theme variable
    <Box sx={{ p: 0, bgcolor: "background.paper" }}>

      <Stack spacing={4}>
        {/* Project Input Form */}
        <Paper
          elevation={0}
          sx={{
            p: { xs: 2, sm: 3 },
            bgcolor: "background.paper",
            border: theme => `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
            boxShadow: theme => `0 4px 20px ${alpha(theme.palette.common.black, 0.05)}`,
            borderRadius: "20px",
          }}
        >

          <Typography
            variant="h6"
            sx={{
              // CHANGED: Replaced hardcoded color with theme variable
              color: "primary.main",
              fontWeight: "bold",
              textTransform: "uppercase",
              fontSize: { xs: "0.9rem", sm: "1rem" },
              mb: 3,
            }}
          >
            Project
          </Typography>
          <Stack spacing={3}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Project Name" // CHANGED: Using label instead of placeholder for better accessibility and theme integration
                  value={projectName}
                  onChange={(e) => setProjectName(e.target.value)}
                  variant="outlined"
                  required
                  // CHANGED: sx prop removed as styles are now handled by the global theme
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Project Link" // CHANGED: Using label instead of placeholder
                  value={projectUrl}
                  onChange={(e) => setProjectUrl(e.target.value)}
                  variant="outlined"
                  // CHANGED: sx prop removed
                />
              </Grid>
            </Grid>
            <TextField
              fullWidth
              multiline
              rows={4}
              label="Project Description" // CHANGED: Using label instead of placeholder
              value={projectDesc}
              onChange={(e) => setProjectDesc(e.target.value)}
              variant="outlined"
              required
              // CHANGED: sx prop removed
            />
            <Button
              variant="contained"
              onClick={handleProjectAdd}
              startIcon={<Add />}
              color="primary"
              sx={{
                alignSelf: "flex-end",
                textTransform: "none",
                fontWeight: "bold",
                borderRadius: "12px",
                px: 4,
                py: 1.5,
                boxShadow: theme => `0 4px 14px ${alpha(theme.palette.primary.main, 0.3)}`,
              }}
            >
              Add Project
            </Button>

          </Stack>
        </Paper>

        {/* Display Added Projects */}
        <Box>
          <Typography
            variant="h6"
            gutterBottom
            sx={{
              // CHANGED: Replaced hardcoded color with theme variable
              color: "primary.main",
              fontWeight: "bold",
              textTransform: "uppercase",
              fontSize: { xs: "0.9rem", sm: "1rem" },
            }}
          >
            Your Projects ({profileData.projects?.length || 0})
          </Typography>
          {!profileData.projects || profileData.projects.length === 0 ? (
            <Paper
              elevation={0}
              sx={{
                p: 4,
                textAlign: "center",
                bgcolor: "background.paper",
                border: theme => `1px dashed ${alpha(theme.palette.primary.main, 0.3)}`,
                borderRadius: "20px",
              }}
            >

              <Typography sx={{ color: "text.secondary" }} variant="body1">
                No projects added yet.
              </Typography>
            </Paper>
          ) : (
            <Stack spacing={2}>
              {(profileData.projects || []).map((proj, index) => (
                <Paper
                  key={index}
                  elevation={0}
                  sx={{
                    p: 3,
                    bgcolor: "background.paper",
                    border: theme => `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
                    boxShadow: theme => `0 2px 12px ${alpha(theme.palette.common.black, 0.03)}`,
                    borderRadius: "16px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >

                  <Box>
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: "bold",
                        fontSize: { xs: "1rem", sm: "1.1rem" },
                        // CHANGED: Replaced hardcoded color with theme variable
                        color: "text.primary",
                      }}
                    >
                      {proj.name}
                    </Typography>
                    {proj.url && (
                      <Link
                        href={proj.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        variant="body2"
                        // CHANGED: Use color prop for Link
                        color="primary"
                        sx={{ mt: 0.5, display: "block" }}
                      >
                        {proj.url}
                      </Link>
                    )}
                    <Typography
                      variant="body2"
                      // CHANGED: Replaced hardcoded color with theme variable
                      sx={{ color: "text.secondary", mt: 0.5 }}
                    >
                      {proj.description}
                    </Typography>
                  </Box>
                  <IconButton
                    onClick={() => handleDeleteProject(index)}
                    // CHANGED: Replaced sx color with color prop
                    color="error"
                  >
                    <Delete />
                  </IconButton>
                </Paper>
              ))}
            </Stack>
          )}
        </Box>
      </Stack>
    </Box>
  );
};

export default ProjectsStep;
